import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import changeFormValueValidator from "./middlewares/changeFormValueValidator";
import submitFormValueValidator from "./middlewares/submitFormValueValidator";
import toLower from "lodash/toLower";
import "bootstrap/dist/css/bootstrap.min.css";
import "@mdi/font/css/materialdesignicons.css";
import "animate.css/animate.css";
import "./index.css";
import "moment/min/locales";
import "numeral/locales";
import locales from "./locales";
import reducers from "./reducers";
import flows from "./flows";
import AppRoutes from "./AppRoutes";
import numeral from "numeral";
import { setConfig } from "./config";

//set de default locale
numeral.locale("en-au");

const sagaMiddleware = createSagaMiddleware();

const middleware = [changeFormValueValidator, submitFormValueValidator, sagaMiddleware];

const store = createStore(reducers, compose(applyMiddleware(...middleware)));

sagaMiddleware.run(flows);

locales.setLanguage(toLower(navigator.language || navigator.languages[0]).split("-")[0]);

setConfig({
  endpointUrl: process.env.REACT_APP_API_URL,
  speechRecognitionEndpointUrl: process.env.REACT_APP_SPEECH_RECOGNITION_API_URL + "/speech-recognition",
  speechRecognitionKey: process.env.REACT_APP_SPEECH_RECOGNITION_API_KEY,
  assetsUrl: process.env.REACT_APP_FILES_URL,
  setToken: (token) => sessionStorage.setItem("accessToken", token),
  getToken: () => sessionStorage.getItem("accessToken"),
  onLogout: () => {
    sessionStorage.clear();
    if (window.location.pathname !== "/login") {
      window.location.reload();
    }
  },
});

render(
  <Provider store={store}>
    <AppRoutes />
  </Provider>,
  document.getElementById("root")
);
